import "./videos.css";
import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import { useNavigate } from "react-router-dom";
import BtnVoltar from "../../components/btn-voltar/btn-voltar.jsx";
import Modal from "../../components/modal/modal.jsx";
import Swal from "sweetalert2";

function Videos() {
  const navigate = useNavigate();

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ativando, setAtivando] = useState(null);

  const [open, setOpen] = useState(false);
  const [modo, setModo] = useState("editar"); // editar | inserir
  const [tipo, setTipo] = useState(null);     // video | capa
  const [arquivo, setArquivo] = useState(null);
  const [videoAtual, setVideoAtual] = useState(null);

  async function carregarVideos() {
    try {
      setLoading(true);
      const res = await api.get("/videos");
      setVideos(res.data || []);
    } catch {
      Swal.fire("Erro", "Erro ao buscar vídeos", "error");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    carregarVideos();
  }, []);

  async function ativarVideo(id) {
    try {
      setAtivando(id);
      await api.put(`/videos/${id}/ativar`);
      await carregarVideos();
    } catch {
      Swal.fire("Erro", "Erro ao ativar vídeo", "error");
    } finally {
      setAtivando(null);
    }
  }

  async function excluirVideo(video) {
    const result = await Swal.fire({
      title: "Excluir vídeo?",
      text: "Essa ação não pode ser desfeita",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Excluir",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
    });

    if (!result.isConfirmed) return;

    try {
      await api.delete(`/videos/${video.id_video}`);
      await carregarVideos();

      Swal.fire("Excluído!", "Vídeo removido com sucesso", "success");
    } catch {
      Swal.fire("Erro", "Erro ao excluir vídeo", "error");
    }
  }

  /* ================= MODAIS ================= */

  function abrirEditarVideo(video) {
    setModo("editar");
    setTipo("video");
    setVideoAtual(video);
    setArquivo(null);
    setOpen(true);
  }

  function abrirEditarCapa(video) {
    setModo("editar");
    setTipo("capa");
    setVideoAtual(video);
    setArquivo(video.capa_video);
    setOpen(true);
  }

  function abrirInserirVideo() {
    setModo("inserir");
    setTipo("video");
    setVideoAtual(null);
    setArquivo(null);
    setOpen(true);
  }

  async function enviarEdit() {
    const formData = new FormData();

    if (modo === "inserir") {
      formData.append("video", arquivo);
      await api.post("/videos", formData);
    }

    if (modo === "editar" && tipo === "video") {
      formData.append("video", arquivo);
      await api.put(`/videos/${videoAtual.id_video}`, formData);
    }

    if (modo === "editar" && tipo === "capa") {
      formData.append("capa_video", arquivo);
      await api.put(`/videos/${videoAtual.id_video}/capa`, formData);
    }

    setOpen(false);
    await carregarVideos();
  }

  if (loading) {
    return <p style={{ marginTop: "2rem" }}>Carregando vídeos...</p>;
  }

  // 🔥 VÍDEO ATIVO SEMPRE PRIMEIRO
  const videosOrdenados = [
    ...videos.filter(v => v.ativo),
    ...videos.filter(v => !v.ativo),
  ];

  return (
    <div className="container-banners">
      <div className="header-banners">
        <h1>Vídeos</h1>

        <div className="header-actions">
          <button className="btn-inserir-video" onClick={abrirInserirVideo}>
            Inserir vídeo
          </button>

          <BtnVoltar voltar={() => navigate("/home")} />
        </div>
      </div>

      <div className="banners">
        {videosOrdenados.map((v) => (
          <div className="banner" key={v.id_video}>
            {v.capa_video && <img src={v.capa_video} alt="capa" />}
            {v.video_url && <video src={v.video_url} controls />}

            {v.ativo && (
              <span className="video-ativo">VÍDEO DA HOME</span>
            )}

            <div className="buttons-banners">
              {!v.ativo && (
                <button
                  disabled={ativando === v.id_video}
                  onClick={() => ativarVideo(v.id_video)}
                >
                  {ativando === v.id_video ? "Ativando..." : "Ativar"}
                </button>
              )}

              <button onClick={() => abrirEditarVideo(v)}>
                Editar vídeo
              </button>

              <button onClick={() => abrirEditarCapa(v)}>
                Editar capa
              </button>

              <button
                className="btn-excluir"
                onClick={() => excluirVideo(v)}
              >
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={enviarEdit}
        tipo={tipo === "video" ? "video" : "banner"}
        modo={modo}
        img={arquivo}
        setImg={setArquivo}
      />
    </div>
  );
}

export default Videos;
